













  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { XEventsTypes } from '../../wiring/events.types';
  import { WireMetadata } from '../../wiring/wiring.types';
  import BaseEventButton from '../base-event-button.vue';
  import { XOn } from '../decorators/bus.decorators';

  /**
   * Component containing an event button that emits
   * {@link XEventsTypes.UserClickedPanelToggleButton} when clicked with
   * the panelId as payload.
   *
   * It has a default slot to customize its contents.
   *
   * @public
   */
  @Component({
    components: { BaseEventButton }
  })
  export default class BaseIdTogglePanelButton extends Vue {
    /**
     * The panel state to pass through the slot.
     */
    protected isPanelOpen = false;

    /** The panelId to use for the toggle event listeners. */
    @Prop({ required: true })
    protected panelId!: string;

    /**
     * List of events to emit by the BaseEventButton.
     *
     * @returns An object with the event and payload.
     *
     * @internal
     */
    protected get events(): Partial<XEventsTypes> {
      return { UserClickedPanelToggleButton: this.panelId };
    }

    /**
     * The subscription to the {@link XEventsTypes.TogglePanelStateChanged} event
     * to update the `isPanelOpen` property.
     *
     * @param newState - The new isOpen state of the panel.
     * @param id - The `panelId`.
     */
    @XOn('TogglePanelStateChanged')
    updatePanelState(newState: boolean, { id }: WireMetadata): void {
      if (this.panelId === id) {
        this.isPanelOpen = newState;
      }
    }
  }
